import styled from 'styled-components';

export const CardSearch = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const Footer = styled.div`
  display: flex;
  height: 80px;
  align-items: center;
  justify-content: flex-end;

  div {
    width: 200px;
  }
`;
export const ContainerPagination = styled.div`
display: flex;
justify-content: center;

`;
export const ContainerLoading = styled.div`
display: flex;
justify-content: center;`;

// ===>

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  justify-content: space-evenly;
  flex-grow: 1;
`;
export const Margin = styled.div`
  margin: 10px 20px 20px 40px;
  display: flex;
  width: 100%;
`;
